import { Link } from "react-router-dom";
import React, { Component } from "react";

const DEFAULT_LOCAL_LNG = "fr";

class LocalizedLink extends Component {
  render() {
    const { to, lng, className, style, children } = this.props;
    var localizedTo = "";

    if (this.props.from==="header") {
      localizedTo = `${to}`;
    }
    else {
      localizedTo = lng === DEFAULT_LOCAL_LNG ? to : `/${lng}${to}`;
    }
    return (
      <Link className={className} to={localizedTo} style={style}>
        {children}
      </Link>
    );
  }
}

export default LocalizedLink;



// WEBPACK FOOTER //
// ./src/components/LocalizedLink.js